import { createModuleStore } from '../utils'

export const useOngoingUserSessionsStore = createModuleStore(
  'ongoing-user-sessions',
  {
    type: 'Ongoing User Session',
    pageHeading: 'Online Users',
    sortingOn: 'toolbar',
    uploadOptionsCsv: '',
    downloadOptionsCsv: '',
    noActivate: true,
    noCopy: true,
    noHistory: true,
    noStatus: true,
    noDeactivate: true,
    noDelete: true,
    noTimeline: true,
    noEdit: true,
    noAdd: true,
    noSort: true,
    noSettings: true,
    noColumnSelection: true,
    uri: '/users/ongoing-sessions',
    serviceUri: '/users/ongoing-sessions',
    listingModuleName: 'AccessControl',
    listingActivityName: 'View Ongoing User Sessions',
    formModuleName: 'AccessControl',
    formActivityName: 'Control Ongoing User Sessions',
    allFields: [
      {
        key: 'user.username',
        title: 'USERNAME',
        visible: true,
        sortable: true,
        disabled: true,
      },
      {
        key: 'user.name',
        title: 'NAME',
        visible: true,
        sortable: true,
        disabled: true,
      },
      {
        key: 'user.email',
        title: 'EMAIL',
        visible: true,
        sortable: true,
        disabled: true,
      },
      {
        key: 'handle',
        title: 'HANDLE',
        visible: true,
        disabled: true,
        sorter: 'default',
      },
      {
        key: 'loginTimestamp',
        title: 'LOGIN TIME',
        visible: true,
        sortable: true,
        disabled: true,
        type: 'datetime',
        sorter: 'default',
      },
      {
        key: 'expireTimestamp',
        title: 'EXPIRY TIME',
        visible: true,
        sortable: true,
        disabled: true,
        type: 'datetime',
        sorter: 'default',
      },
    ],
  },
  {},
  {},
  {}
)
